export default "__VITE_ASSET__563a683b__"